<div class="sync-status-tile">
    <div class="status-icon">
        <mydocma-custom-mat-icon [iconName]="'_warning-filled'" style="color: orange; font-size: 12px" *ngIf="syncState.SyncStatus === syncStatus.NotSync">
        </mydocma-custom-mat-icon>
        <mydocma-custom-mat-icon [iconName]="'_high-priority'" style="color: red; font-size: 12px" *ngIf="syncState.SyncStatus === syncStatus.Error">
        </mydocma-custom-mat-icon>
    </div>
    <div class="status-data">
        <div class="numbers">{{ syncState.Number1 }}{{(syncState.Number1 && syncState.Number2) ? ' - ' : ''}}{{ syncState.Number2 }}</div>
        <div class="description">{{ syncState.Desc1_1 }}</div>
        <div class="date">{{ 'MM.syncFaults.dialog.colModifiedOn' | translate }}: {{ syncState.ModifiedOn | mydocmaDate:'medium' }}</div>
        <div class="date">{{ 'MM.syncFaults.dialog.colLastSyncAttemptOn' | translate }}: {{ syncState.LastSyncAttemptOn | mydocmaDate:'medium' }}</div>
        <div class="error">{{ syncState.Error }}</div>
    </div>
 </div>